import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgHeartFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      d="M5.987 1.102a7.197 7.197 0 0 1 5.983 1.71l.045.04.04-.037a7.197 7.197 0 0 1 5.678-1.727l.295.043a7.197 7.197 0 0 1 4.035 12.004l-.216.222-.058.05-8.936 8.85a1.2 1.2 0 0 1-1.575.098l-.112-.098-8.988-8.902a7.197 7.197 0 0 1 3.81-12.253Z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgHeartFilled);
export default ForwardRef;
